import { render } from "./ContentCreation.vue?vue&type=template&id=0e216ff2&scoped=true"
import script from "./ContentCreation.vue?vue&type=script&lang=js"
export * from "./ContentCreation.vue?vue&type=script&lang=js"

import "./ContentCreation.vue?vue&type=style&index=0&id=0e216ff2&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e216ff2"]])

export default __exports__